import { useEffect, useState } from "react";
import TagManager from "react-gtm-module";
import { useParams } from "react-router-dom";
import Typewriter from 'typewriter-effect';
import Header from "../components/header";
import { JobObjectiveModel, SignupModelHelper } from "../data/SignupModel";
import { dataLayerHelper } from "../data/dataLayerModel";
import AmarelinhoService from "../services/AmarelinhoService";

export default function PerguntasInicio(props: any) {

    const {
        profissaoId,
    } = useParams();

    const [typed, setTyped] = useState(false);
    const [survey, setSurvey]: any = useState();

    useEffect(() => {
        SignupModelHelper.checkLogin(true);
        
        TagManager.dataLayer(dataLayerHelper.pagina('tipo', 'perguntas-inicio'));
    }, []);

    useEffect(() => {
        // console.log( {survey} );
    }, [survey])

    async function setJob(isSurvey: boolean) {

        if (isSurvey) {

            SignupModelHelper.update({
                objectives: [{
                    id: profissaoId,
                    value: 'surveyJob',
                    label: 'Survey Job'
                } as JobObjectiveModel]
            });

            const signup = SignupModelHelper.get();
            if (signup) {
                await AmarelinhoService.saveObjectives(signup);
                // TagManager.dataLayer(dataLayerHelper.formEnviado('form_vagas-perguntas'));
            }
    
            document.location = '#/perguntas/'+survey.title+'/'+survey.id+'/0';
        }
    }

    let optionItemsList: any = [
        { label: "Quero Responder", value: true },
        { label: "Agora não", value: false },
    ];

    let optionItems = optionItemsList.map((c: any) => {

        return <div className="option-item mt-3" key={optionItemsList.indexOf(c)}>
            <button className={`btn btn-outline btn-full`} onClick={ () => setJob(c.value)}>{c.label}</button>
        </div>;
    });

    return (
        <>
            <Header step={1} total={1} title="Perguntas" previous=""></Header>

            <div className="chat-container">

                <div className="chat">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 d-flex flex-column align-items-stretch justify-content-between">

                                <div className="chat-item">
                                    <img src="./images/ico-chat-amarelinho.svg" alt="Amarelinho" />
                                    <div className="chat-item-content">
                                        <Typewriter
                                            onInit={(typewriter) => {
                                                typewriter
                                                .changeDelay(15)
                                                .typeString(`Para aumentar suas chances de conquistar essa vaga, responda as perguntas a seguir sobre a profissão escolhida.`)
                                                .callFunction(() => {
                                                    setTyped(true)
                                                })
                                                .start();
                                        }} />
                                    </div>
                                </div>

                                { typed && survey &&
                                <div className="option-list">
                                    {
                                        optionItems.map((objItem: any) => {
                                            return objItem;
                                        })
                                    }
                                </div>
                                }

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>);
}
